export default "__VITE_ASSET__CDz0wrRn__"